import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core'
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
} from '@angular/forms'
import {
  SearchContactTypeModel,
} from '../../../core/models/contact-type.model'
import { MatButtonModule } from '@angular/material/button'
import { MatFormField, MatFormFieldModule, MatLabel } from '@angular/material/form-field'
import { MatInput, MatInputModule } from '@angular/material/input'
import { MatSelectModule } from '@angular/material/select'


import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog'
import { DocumentTypeService } from '../../../core/services/document/document-type/document-type.service'
import { MatIconModule } from '@angular/material/icon'
import { MatExpansionPanel, MatExpansionPanelHeader, MatExpansionPanelTitle } from '@angular/material/expansion'
import { MatDatepickerModule } from '@angular/material/datepicker'
import { MatNativeDateModule } from '@angular/material/core'
import { CommonModule } from '@angular/common';
import { TableListComponent } from '../../../shared/components/table-list/table-list.component'
import { MatProgressBar } from '@angular/material/progress-bar'
import { MatTableModule } from '@angular/material/table'
import { MatPaginator } from '@angular/material/paginator'
import { NgxMaskDirective, provideNgxMask } from 'ngx-mask'
import { PassengerService } from '../../../core/services/passenger/passenger.service'
import { PaginationComponent } from '../../../shared/components/pagination/pagination.component'
import { PassengerOrdemService } from '../../../core/services/passenger/passenger-os/passenger-os.service'
import { MatSpinner } from '@angular/material/progress-spinner'
import { SnackbarCustomService } from '../../../shared/components/snackbar/snackbar-custom.service'
import { PurchasesServiceOrderService } from '../../../core/services/purchases/purchases-service-order/purchases-service-order.service'
import { MatCardModule } from "@angular/material/card";
import { MatSlideToggleModule } from '@angular/material/slide-toggle'
import { VehicleTypeService } from '../../../core/services/vehicle/vehicle-type/vehicle-type.service'
import { DriverTypeService } from '../../../core/services/driver/driver-type/driver-type.service'
import { ServiceOrderService } from '../../../core/services/service/service-order/service-order.service'
import { MatCheckboxModule } from '@angular/material/checkbox'
import { MatDivider } from "@angular/material/divider";

@Component({
  selector: 'modal-by-buy',
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatFormField,
    MatInput,
    MatLabel,
    MatSelectModule,
    PaginationComponent,
    MatProgressBar,
    MatIconModule,
    TableListComponent,
    MatExpansionPanel,
    MatExpansionPanelHeader,
    MatExpansionPanelTitle,
    MatTableModule,
    MatPaginator,
    MatFormFieldModule,
    MatInputModule,
    MatDatepickerModule,
    MatNativeDateModule,
    NgxMaskDirective,
    MatSpinner,
    MatCardModule,
    MatSlideToggleModule,
    MatCheckboxModule,
    MatDivider
  ],
  templateUrl: './modal-by-buy.component.html',
  styleUrl: './modal-by-buy.component.scss',
  standalone: true,
  providers: [provideNgxMask({
    dropSpecialCharacters: false
  })],
})
export class ModalByBuyComponent implements OnInit {
  constructor(
    private formBuilder: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<ModalByBuyComponent>,
    private dialog: MatDialog,
    private passangerService: PassengerService,
    private passangerOs: PassengerOrdemService,
    private documentTypeService: DocumentTypeService,
    private snackbar: SnackbarCustomService,
    private vehicleService: VehicleTypeService,
    private driverService: DriverTypeService,
    private purchaseService: PurchasesServiceOrderService,
    private serviceOrderService: ServiceOrderService
  ) { }

  @Output() response = new EventEmitter<any>()

  form!: FormGroup;
  passengers: any[] = []; // Agora a lista vem da API
  loading = false;

  toggleActive: any = false

  documentMask = '';
  columns: any[] = [
    {
      keyColumn: 'nome',
      key: 'nome',
      description: 'Nome',
    },
    {
      keyColumn: 'documento',
      key: 'documento',
      description: 'Documento',
    },
    {
      keyColumn: 'contato',
      key: 'contato',
      description: 'Contato',
    },
    {
      keyColumn: 'companhia',
      key: 'companhia',
      description: 'Companhia',
    },
    {
      keyColumn: 'vao',
      key: 'vao',
      description: 'Vão',
    },
    {
      keyColumn: 'action',
      key: { add: true },
      description: 'Ações',
    }
  ];
  cellphoneMask = '(00) 00000-0000';

  page = 1;
  rows = 10;
  numberRows = 0;
  itemsList: any[] = []
  passengerOsList: any[] = []
  searchForm: SearchContactTypeModel = new SearchContactTypeModel()
  idForOs: any = ""
  editIndex: number | null = null;
  editAgendaItem: any = null;
  allowedTypes = []
  file: File | null = null

  listTypeDriver: any = []
  listTypeVehicle: any = []
  typeDriver: any = null
  typeVehicle: any = null

  ngOnInit(): void {
    this.createForm();
    this.listTypeVehicles()
    this.listTypeDrivers()



  }

  fillForm() {

    if (!this.form.get('activeDriver')?.value && !this.form.get('activeVehicle')?.value) { // Se estiver ativo (Sim)
      this.toggleActive = false
      this.form.valid

    } else {
      this.toggleActive = true

    }


  }

  listTypeVehicles() {
    this.vehicleService.listVehicleType().subscribe({
      next: (response: any) => {
        this.listTypeVehicle = response.data

      },
      error: (err: any) => {
        console.error(err)
      },
      complete: () => { },
    })
  }

  listTypeDrivers() {
    this.driverService.listDriverType().subscribe({
      next: (response: any) => {
        this.listTypeDriver = response.data

      },
      error: (err: any) => {
        console.error(err)
      },
      complete: () => { },
    })
  }

  pushDatesPurchase() {


    this.loading = true;
    const item = {
      ordemServicoId: this.data.item.codigoOs,
      tipoVeiculoId: this.data.item.tipoVeiculoId,
      tipoMotoristaId: this.data.item.tipoMotoristaId,
      quantidadeVeiculo: this.form.get('activeVehicle')?.value ? 1 : 0,
      quantidadeMotorista: this.form.get('activeDriver')?.value ? 1 : 0,
    }

    this.purchaseService.createPurchasesServiceOrder(item).subscribe({
      next: (res) => {
        this.snackbar.success(res.message);
        this.toUpdateStatus()
        this.dialogRef.close(true);

      },
      error: (err) => {
        this.snackbar.errorRequest('Error ao enviar para compras');
        this.loading = false;
      },
    });
  }


  toUpdateStatus() {
    const item = {
      id: this.data.item.codigoOs,
      statusId: 2
    }

    this.serviceOrderService.editServiceOrderEditStatus(item).subscribe({
      next: (res: any) => {
        this.snackbar.success(res.message)
        this.dialogRef.close()
      },
      error: (error: any) => {
        this.snackbar.error(error.message)
      }
    })
  }

  canSend(): boolean {
    const driver = this.form.get('typeDriver')?.value;
    const vehicle = this.form.get('typeVehicle')?.value;
    // Considera preenchido se for diferente de vazio, null ou 0
    return (driver && driver !== '' && driver !== 0) || (vehicle && vehicle !== '' && vehicle !== 0);
  }

  createForm(): void {
    this.form = this.formBuilder.group({
      activeVehicle: [false],
      typeDriver: [''],
      typeVehicle: [''],
      activeDriver: [false],
    });

  }



  closeModal() {
    this.dialogRef.close();
  }


  cancel() {
    this.form.reset();
  }

}
